import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: false,
    fallbackLng: 'en', // use en if detected lng is not available
    nsSeparator: false, // namespace separator :
    keySeparator: false, // we do not use keys in form messages.welcome
    detection: {
      order: ['querystring','cookie','localStorage','navigator','htmlTag','path','subdomain'],
      caches: ['cookie'],
    },
    supportedLngs: ['en','de','es','fr','it','pl','pt-BR','ko','ru','uk','ja','zh-TW','da','sv'],
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
